import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useInfoStore } from "../../../store/userInfo";
import { useOrderStore } from "../../../store/order";
import {
  Box,
  Button,
  ButtonBase,
  Checkbox,
  FormControlLabel,
  IconButton,
  Modal,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { InputMask, type MaskEventDetail } from "@react-input/mask";
import { isBrowser } from "react-device-detect";
// import close_w from '../../../assets/images/close_w.svg';
import { useWindowDimensions } from "../../../App";
import { toast } from "react-toastify";
import { updateCollect } from "../../../services/order.service";
import { logger } from "../../../utils/logger";

const LazyPicture = styled(LazyLoadImage)`
  object-fit: cover;
  width: ${({ width }) => (width ? `${width}rem` : "100%")};
  height: ${({ width }) => (width ? `${width}rem` : "100%")};

  &.lazy-load-image-background.opacity {
    background-image: none !important;
    opacity: 0;
    transition: opacity 0.3s;
  }

  &.lazy-load-image-background.opacity.lazy-load-image-loaded {
    opacity: 1;
  }
`;

const modal = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  height: "73rem",
  bgcolor: "background.paper",
  borderRadius: "1.5rem",
  boxShadow: "0px 0px 50px 0px rgba(0, 0, 0, 0.40)",
};

const CollectInfo: React.FC = () => {
  const { userInfo } = useInfoStore();
  const { openCollect, collectInfo, setOpenCollect } = useOrderStore();
  const { orientation } = useWindowDimensions();
  const storeId = userInfo?.storeId;
  const [checked, setChecked] = useState(false);
  const [number, setNumber] = useState<MaskEventDetail | null>(null);
  const [openDisclaimer, setOpenDisClaimer] = useState(false);
  const landMode = orientation === "landscape" ? true : false;

  const hideDialog = () => {
    // if (!isBrowser) {
    // 	if (window.ReactNativeWebView !== undefined) {
    // 		window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    // 	} else if(window.Android !== undefined){
    // 		window.Android.postMessage(JSON.stringify({'type':'play'}));
    // 	}
    // }
    setOpenCollect(false);
  };

  const handleMaskChange = (event: CustomEvent<MaskEventDetail>) => {
    logger.debug(event.detail);
    setNumber(event.detail); // Update the state with the event's detail
  };

  const validatePhoneNumber = (phone: MaskEventDetail | null): boolean => {
    if (!phone || !phone.value) return false;

    // Updated regex to match (123)112-1123 format
    const phoneRegex = /^\(\d{3}\)\d{3}-\d{4}$/;
    return phoneRegex.test(phone.value.trim());
  };

  const handleGetOffer = () => {
    // if (!isBrowser) {
    // 	if (window.ReactNativeWebView !== undefined) {
    // 		window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    // 	} else if(window.Android !== undefined){
    // 		window.Android.postMessage(JSON.stringify({'type':'play'}));
    // 	}
    // }
    if (!checked) {
      toast.error("Please agree to Terms and Conditions");
      return;
    }
    if (!number || !validatePhoneNumber(number)) {
      toast.error("Please enter a valid phone number.");
      return;
    }
    updateCollect(storeId, number.value, collectInfo).then(
      () => {
        hideDialog();
      },
      () => {}
    );
  };

  return (
    <>
      <Modal
        keepMounted
        disableScrollLock
        disableEnforceFocus
        hideBackdrop
        open={openCollect}
        onClose={hideDialog}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          background: "rgba(0,0,0,0.5)",
          "& .MuiBackdrop-root": {
            backgroundColor: "transparent",
          },
        }}
      >
        <Box
          sx={{
            ...modal,
            height: landMode ? "73rem" : "auto",
            maxHeight: landMode ? "73rem" : "90%",
            overflow: landMode ? "hidden" : "auto",
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: landMode ? "11.2rem" : "auto",
              padding: "3.0rem",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "1.0rem",
              backgroundColor: "#f00",
              borderRadius: "1.5rem 1.5rem 0rem 0rem",
              position: landMode ? "relative" : "sticky",
              top: 0,
              zIndex: 1,
            }}
          >
            <Typography
              sx={{
                textAlign: "center",
                fontSize: "3.0rem",
                fontStyle: "normal",
                fontWeight: "900",
                lineHeight: "150%",
                letterSpacing: ".15rem",
                color: "#fff",
              }}
            >
              YOUR CHECK IS ON THE WAY
            </Typography>
          </Box>
          <div
            className="touch-area"
            style={{
              position: "absolute",
              right: "3.0rem",
              top: "1.4rem",
              zIndex: 2,
            }}
            onClick={hideDialog}
          >
            <IconButton aria-label="close">
              <LazyPicture
                sx={{ width: "2.0rem", height: "2.0rem" }}
                src={process.env.PUBLIC_URL + "/assets/images/close_w.svg"}
                alt="close"
                effect="opacity"
              />
            </IconButton>
          </div>
          {landMode ? (
            <Box
              sx={{
                padding: "1rem 4.2rem",
                overflow: "hidden",
                maxHeight: "61.8rem",
                display: "flex",
                flexDirection: "column",
                gap: "7.0rem",
              }}
            >
              <Stack
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "7.0rem",
                }}
              >
                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "baseline",
                      gap: "2.3rem",
                      width: "auto",
                      minWidth: "fit-content",
                      height: "7.2rem",
                    }}
                  >
                    <img
                      src={process.env.PUBLIC_URL + "/assets/images/flame2.svg"}
                      style={{ width: "7.0rem", height: "7.2rem" }}
                      alt="flame2"
                    />
                    <Typography
                      sx={[
                        {
                          fontSize: "3.6rem",
                          fontWeight: "800",
                          fontStyle: "normal",
                          lineHeight: "normal",
                          letterSpacing: ".072rem",
                          color: "#000",
                          textAlign: "center",
                        },
                      ]}
                    >
                      BEFORE YOU GO
                    </Typography>
                    <img
                      src={process.env.PUBLIC_URL + "/assets/images/flame1.svg"}
                      style={{ width: "7.0rem", height: "7.2rem" }}
                      alt="flame1"
                    />
                  </Box>
                  <Typography
                    sx={[
                      {
                        fontSize: "2.0rem",
                        fontWeight: "500",
                        fontStyle: "normal",
                        color: "#000",
                        textAlign: "center",
                      },
                    ]}
                  >
                    Sign up to receive exclusive offers and updates.
                  </Typography>
                </Box>
                <Box>
                  <Stack
                    sx={{
                      gap: "1.9rem",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FormControlLabel
                      value={checked}
                      control={
                        <Checkbox
                          sx={{
                            backgroundColor: "#fff",
                            transform: "scale(1.5)",
                          }}
                          onChange={(e) => setChecked(e.target.checked)}
                        />
                      }
                      label={
                        <Typography
                          sx={{
                            textAlign: "left",
                            fontSize: "1.5rem",
                            fontStyle: "normal",
                            fontWeight: "500",
                            lineHeight: "normal",
                            ml: "1.5rem",
                          }}
                        >
                          I am 16 years old or older and agree to Terms and
                          Conditions of Z-Order and its Privacy Policy.
                        </Typography>
                      }
                      sx={{ width: "41.1rem" }}
                    />
                    <InputMask
                      style={{
                        width: "41.1rem",
                        height: "6.9rem",
                        padding: "18px 61px",
                        textAlign: "center",
                      }}
                      mask="(___)___-____"
                      placeholder="Enter the phone number"
                      type="tel"
                      replacement={{ _: /\d/ }}
                      value={number?.value || ""}
                      onMask={handleMaskChange}
                    />
                    <ButtonBase
                      sx={{
                        width: "auto",
                        minWidth: "fit-content",
                        height: "5.0rem",
                        padding: ".4rem 3.3rem",
                        background: "#F72E13",
                        borderRadius: "3.0rem",
                        borderRight: "1.0rem",
                        zIndex: 1,
                      }}
                      onClick={() => handleGetOffer()}
                    >
                      <Typography
                        sx={{
                          fontSize: "2.6rem",
                          fontStyle: "normal",
                          fontWeight: "600",
                          lineHeight: "150%",
                          color: "#fff",
                          textAlign: "center",
                          textTransform: "none",
                        }}
                      >
                        Get Offers
                      </Typography>
                    </ButtonBase>
                  </Stack>
                </Box>
                <Stack
                  sx={{
                    position: "absolute",
                    bottom: "0.5rem",
                    width: "100%",
                    paddingX: "4.2rem",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "flex-end",
                    }}
                  >
                    <img
                      src={process.env.PUBLIC_URL + "/assets/images/gift1.svg"}
                      alt="gift1"
                      style={{ width: "14.5rem", height: "14.7rem" }}
                    />
                    <img
                      src={process.env.PUBLIC_URL + "/assets/images/gift2.svg"}
                      alt="gift2"
                      style={{ width: "15.65rem", height: "19.75rem" }}
                    />
                  </Box>
                  <Typography
                    sx={{
                      width: "100%",
                      color: "rgba(0, 0, 0, 0.70)",
                      fontSize: "1.1rem",
                      fontWeight: "400",
                      fontStyle: "normal",
                      textWrap: "pretty",
                    }}
                    onClick={() => setOpenDisClaimer(true)}
                  >
                    By clicking the button above and then signing up via text,
                    you agree to receive recurring automated marketing
                    communications (inc. shopping cart reminders) at the phone
                    number which you use to sign up via text. Message frequency
                    varies. Consent is not a condition of purchase. Reply STOP
                    to unsubscribe. Reply HELP for help. MSG & Data Rates may
                    apply. By signing up via text you agree to the Privacy
                    Policy and Terms and Conditions.
                  </Typography>
                </Stack>
              </Stack>
            </Box>
          ) : (
            <Box
              sx={{
                padding: "1rem 4.2rem",
                overflow: "auto",
                maxHeight: "calc(100% - 11.2rem)",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Stack spacing={4}>
                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "baseline",
                      gap: "2.3rem",
                      width: "100%",
                      height: "7.2rem",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "baseline",
                        gap: "2.3rem",
                      }}
                    >
                      <img
                        src={
                          process.env.PUBLIC_URL + "/assets/images/flame2.svg"
                        }
                        style={{ width: "7.0rem", height: "7.2rem" }}
                        alt="flame2"
                      />
                      <Typography
                        sx={[
                          {
                            fontSize: "3.6rem",
                            fontWeight: "800",
                            fontStyle: "normal",
                            lineHeight: "normal",
                            letterSpacing: ".072rem",
                            color: "#000",
                            textAlign: "center",
                            whiteSpace: "nowrap",
                          },
                        ]}
                      >
                        BEFORE YOU GO
                      </Typography>
                      <img
                        src={
                          process.env.PUBLIC_URL + "/assets/images/flame1.svg"
                        }
                        style={{ width: "7.0rem", height: "7.2rem" }}
                        alt="flame1"
                      />
                    </Box>
                  </Box>
                  <Typography
                    sx={[
                      {
                        fontSize: "2.0rem",
                        fontWeight: "500",
                        fontStyle: "normal",
                        color: "#000",
                        textAlign: "center",
                        marginTop: "1rem",
                      },
                    ]}
                  >
                    Sign up to receive exclusive offers and updates.
                  </Typography>
                </Box>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Stack
                    spacing={2}
                    sx={{ width: "41.1rem", alignItems: "center" }}
                  >
                    <FormControlLabel
                      value={checked}
                      control={
                        <Checkbox
                          sx={{
                            backgroundColor: "#fff",
                            transform: "scale(1.5)",
                          }}
                          onChange={(e) => setChecked(e.target.checked)}
                        />
                      }
                      label={
                        <Typography
                          sx={{
                            textAlign: "left",
                            fontSize: "1.5rem",
                            fontStyle: "normal",
                            fontWeight: "500",
                            lineHeight: "normal",
                            ml: "1.5rem",
                          }}
                        >
                          I am 16 years old or older and agree to Terms and
                          Conditions of Z-Order and its Privacy Policy.
                        </Typography>
                      }
                      sx={{ width: "100%" }}
                    />
                    <InputMask
                      style={{
                        width: "100%",
                        height: "6.9rem",
                        padding: "18px 31px",
                        textAlign: "center",
                        fontSize: "1.8rem",
                      }}
                      mask="(___)___-____"
                      placeholder="Enter the phone number"
                      type="tel"
                      replacement={{ _: /\d/ }}
                      value={number?.value || ""}
                      onMask={handleMaskChange}
                    />
                    <ButtonBase
                      sx={{
                        width: "19.8rem",
                        height: "5.0rem",
                        padding: ".4rem 2.0rem",
                        background: "#F72E13",
                        borderRadius: "3.0rem",
                        borderRight: "1.0rem",
                        margin: "0 auto",
                        zIndex: 1,
                      }}
                      onClick={() => handleGetOffer()}
                    >
                      <Typography
                        sx={{
                          fontSize: "2.6rem",
                          fontStyle: "normal",
                          fontWeight: "600",
                          lineHeight: "150%",
                          color: "#fff",
                          textAlign: "center",
                          textTransform: "none",
                        }}
                      >
                        Get Offers
                      </Typography>
                    </ButtonBase>
                  </Stack>
                </Box>
              </Stack>
              <Box sx={{ marginTop: "auto", paddingTop: "4rem" }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "flex-end",
                  }}
                >
                  <img
                    src={process.env.PUBLIC_URL + "/assets/images/gift1.svg"}
                    alt="gift1"
                    style={{ width: "14.5rem", height: "14.7rem" }}
                  />
                  <img
                    src={process.env.PUBLIC_URL + "/assets/images/gift2.svg"}
                    alt="gift2"
                    style={{ width: "15.65rem", height: "19.75rem" }}
                  />
                </Box>
                <Typography
                  sx={{
                    width: "100%",
                    color: "rgba(0, 0, 0, 0.70)",
                    fontSize: "1.1rem",
                    fontWeight: "400",
                    fontStyle: "normal",
                    textWrap: "pretty",
                    marginTop: "1rem",
                  }}
                  onClick={() => setOpenDisClaimer(true)}
                >
                  By clicking the button above and then signing up via text, you
                  agree to receive recurring automated marketing communications
                  (inc. shopping cart reminders) at the phone number which you
                  use to sign up via text. Message frequency varies. Consent is
                  not a condition of purchase. Reply STOP to unsubscribe. Reply
                  HELP for help. MSG & Data Rates may apply. By signing up via
                  text you agree to the Privacy Policy and Terms and Conditions.
                </Typography>
              </Box>
            </Box>
          )}
        </Box>
      </Modal>
      {openDisclaimer ? (
        <DisclaimerNotice setOpenDisClaimer={setOpenDisClaimer} />
      ) : (
        <></>
      )}
    </>
  );
};

const DisclaimerNotice = (props: any) => {
  const { setOpenDisClaimer } = props;
  const hideDialog = () => {
    // if(!isBrowser && window.ReactNativeWebView !== undefined)
    // 	window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    setOpenDisClaimer(false);
  };
  const rawHTML = `
		<h3>Privacy Policy</h3>
		<small>Last updated: December 06, 2022.</small>
		<small>This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.</small>
		<small>We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy. This Privacy Policy has been created with the help of the <a href="https://www.termsfeed.com/privacy-policy-generator/" target="_blank">TermsFeed Privacy Policy Generator</a>.</small>
		<h3>Interpretation and Definitions</h3>
		<h4><small>Interpretation</small></h4>
		<small>The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</small>
		<h3>Definitions</h3>
		<small>For the purposes of this Privacy Policy:</small>
		<ul>
		<li>
		<small><strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.</small>
		</li>
		<li>
		<small><strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control with a party, where &quot;control&quot; means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.</small>
		</li>
		<li>
		<small><strong>Application</strong> means the software program provided by the Company downloaded by You on any electronic device, named Z ORDER</small>
		</li>
		<li>
		<small><strong>Company</strong> (referred to as either &quot;the Company&quot;, &quot;We&quot;, &quot;Us&quot; or &quot;Our&quot; in this Agreement) refers to Z ORDER INC., 3407 W 6TH STREET.</small>
		</li>
		<li>
		<small><strong>Country</strong> refers to: California,  United States</small>
		</li>
		<li>
		<small><strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.</small>
		</li>
		<li>
		<small><strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.</small>
		</li>
		<li>
		<small><strong>Service</strong> refers to the Application.</small>
		</li>
		<li>
		<small><strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.</small>
		</li>
		<li>
		<small><strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).</small>
		</li>
		<li>
		<small><strong>You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</small>
		</li>
		</ul>
		<b><small>Collecting and Using Your Personal Data</small></b>
		<h3>Types of Data Collected</h3>
		<h4>Personal Data</h4>
		<small>While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:</small>
		<ul>
		<li>
		<small>Email address</small>
		</li>
		<li>
		<small>First name and last name</small>
		</li>
		<li>
		<small>Phone number</small>
		</li>
		<li>
		<small>Usage Data</small>
		</li>
		</ul>
		<h4>Usage Data</h4>
		<small>Usage Data is collected automatically when using the Service.</small>
		<small>Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.</small>
		<small>When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.</small>
		<small>We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device.</small>
		<h3>Use of Your Personal Data</h3>
		<small>The Company may use Personal Data for the following purposes:</small>
		<ul>
		<li>
		<small><strong>To provide and maintain our Service</strong>, including to monitor the usage of our Service.</small>
		</li>
		<li>
		<small><strong>To manage Your Account:</strong> to manage Your registration as a user of the Service. The Personal Data You provide can give You access to different functionalities of the Service that are available to You as a registered user.</small>
		</li>
		<li>
		<small><strong>For the performance of a contract:</strong> the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased or of any other contract with Us through the Service.</small>
		</li>
		<li>
		<small><strong>To contact You:</strong> To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation.</small>
		</li>
		<li>
		<small><strong>To provide You</strong> with news, special offers and general information about other goods, services and events which we offer that are similar to those that you have already purchased or enquired about unless You have opted not to receive such information.</small>
		</li>
		<li>
		<small><strong>To manage Your requests:</strong> To attend and manage Your requests to Us.</small>
		</li>
		<li>
		<small><strong>For business transfers:</strong> We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets, whether as a going concern or as part of bankruptcy, liquidation, or similar proceeding, in which Personal Data held by Us about our Service users is among the assets transferred.</small>
		</li>
		<li>
		<small><strong>For other purposes</strong>: We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience.</small>
		</li>
		</ul>
		<small>We may share Your personal information in the following situations:</small>
		<ul>
		<li><small><strong>With Service Providers:</strong></small> We may share Your personal information with Service Providers to monitor and analyze the use of our Service,  to contact You.</li>
		<li><small><strong>For business transfers:</strong></small> We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of Our business to another company.</li>
		<li><small><strong>With Affiliates:</strong></small> We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other subsidiaries, joint venture partners or other companies that We control or that are under common control with Us.</li>
		<li><small><strong>With business partners:</strong></small> We may share Your information with Our business partners to offer You certain products, services or promotions.</li>
		<li><small><strong>With other users:</strong></small> when You share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside.</li>
		<li><small><strong>With Your consent</strong></small>: We may disclose Your personal information for any other purpose with Your consent.</li>
		</ul>
		<h3>Retention of Your Personal Data</h3>
		<small>The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.</small>
		<small>The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer time periods.</small>
		<h3>Transfer of Your Personal Data</h3>
		<small>Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction.</small>
		<small>Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer.</small>
		<small>The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information.</small>
		<h3>Delete Your Personal Data</h3>
		<small>You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You.</small>
		<small>Our Service may give You the ability to delete certain information about You from within the Service.</small>
		<small>You may update, amend, or delete Your information at any time by signing in to Your Account, if you have one, and visiting the account settings section that allows you to manage Your personal information. You may also contact Us to request access to, correct, or delete any personal information that You have provided to Us.</small>
		<small>Please note, however, that We may need to retain certain information when we have a legal obligation or lawful basis to do so.</small>
		<h3>Disclosure of Your Personal Data</h3>
		<h4>Business Transactions</h4>
		<small>If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.</small>
		<h4>Law enforcement</h4>
		<small>Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).</small>
		<h4>Other legal requirements</h4>
		<small>The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:</small>
		<ul>
		<li>Comply with a legal obligation</li>
		<li>Protect and defend the rights or property of the Company</li>
		<li>Prevent or investigate possible wrongdoing in connection with the Service</li>
		<li>Protect the personal safety of Users of the Service or the public</li>
		<li>Protect against legal liability</li>
		</ul>
		<h3>Security of Your Personal Data</h3>
		<small>The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.</small>
		<b><small>Children's Privacy</small></b>
		<small>Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to remove that information from Our servers.</small>
		<small>If We need to rely on consent as a legal basis for processing Your information and Your country requires consent from a parent, We may require Your parent's consent before We collect and use that information.</small>
		<b><small>Links to Other Websites</small></b>
		<small>Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit.</small>
		<small>We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.</small>
		<b><small>Changes to this Privacy Policy</small></b>
		<small>We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page.</small>
		<small>We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the &quot;Last updated&quot; date at the top of this Privacy Policy.</small>
		<small>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</small>
		<b><small>Contact Us</small></b>
		<small>If you have any questions about this Privacy Policy, You can contact us:</small>
		<ul>
		<li><b>By email:</b> info@zorder.net</li>
		</ul>
`;
  return (
    <Modal
      keepMounted
      disableScrollLock
      disableEnforceFocus
      // hideBackdrop
      open={true}
      onClose={hideDialog}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        //You can copy the code below in your theme
        background: "rgba(0,0,0,0.5)",
        "& .MuiBackdrop-root": {
          backgroundColor: "transparent", // Try to remove this to see the result
        },
      }}
    >
      <Box sx={[modal, { padding: "20px 25px", m: 0 }]}>
        <div className="touch-area" onClick={hideDialog}>
          <IconButton
            aria-label="close"
            style={{
              position: "absolute",
              right: "0rem",
              top: "-1.9rem",
              width: "6.6rem",
              height: "6.6rem",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{ position: "relative", width: "100%", height: "100%" }}
            >
              <img
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                }}
                src={process.env.PUBLIC_URL + "/assets/images/close_bg.svg"}
                alt="close"
              />
              <img
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "2.0rem",
                  height: "2.0rem",
                }}
                src={process.env.PUBLIC_URL + "/assets/images/close_w.svg"}
                alt="close"
              />
            </div>
          </IconButton>
        </div>
        <Box sx={{ overflow: "auto", overflowX: "hidden", height: "68.0rem" }}>
          <div
            style={{ fontFamily: "inherit", fontSize: "1rem", color: "#222" }}
          >
            <style>{`
								small {
									font-size: 1.1rem !important;
									line-height: 1.7;
									color: #222;
								}
								@media screen and (max-width: 800px) {
									small { font-size: 1.1rem !important; }
								}
								@supports (-webkit-touch-callout: none) {
									small { font-size: 1.1rem !important; }
								}
							`}</style>
            <div dangerouslySetInnerHTML={{ __html: rawHTML }} />
          </div>
        </Box>
      </Box>
    </Modal>
  );
};

export default CollectInfo;
